// src/views/Restaurant/Configuracion/Integrations/Integrations.tsx
import React, { useState } from 'react';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import Sii from './components/Sii/Sii';


const Integrations: React.FC = () => {
    const [loading] = useState(false);


    const renderHeader = () => {
        return (
          <div className="mp-page-header-container">
            <h2 className='title'>Integraciones</h2>
            <div className='buttons'>

            </div>
          </div>
        );
      }

      if (loading) {
        return <LoadingSpinner text="Cargando dispositivos" transparent={true} />;
      }

      return (
        <div>
          {renderHeader()}
          <Sii/>
        </div>
      );

};
export default Integrations;